var file_upload_viewer_default = {
  "fontElementMap": "AYuwj",
  "file_upload_container": "IsEzX",
  "file_upload_link": "_9OAEv",
  "file_upload_error_container": "_1apSj",
  "file_upload_file_info": "BZWqn",
  "file_upload_type_icon": "hlRo2",
  "file_upload_status_icon_container": "CmxjM",
  "file_upload_status_icon": "s-bR6",
  "file_upload_description": "_1wK7v",
  "file_upload_name_container": "L-Pq7",
  "file_upload_name": "hmqP9",
  "file_upload_extension": "u4BgQ",
  "file_loader_icon": "OOBYB",
  "file_upload_icon_frame": "_5yIRe",
  "file_upload_icon_background": "VSLcd"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
